/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Material_Dialog_DescInputs */

const vi_packaging_material_dialog_desc = /** @type {(inputs: Packaging_Material_Dialog_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khai báo một loại bao bì để kho đếm tồn và trừ khi đóng hàng.`)
};

/**

* @param {Packaging_Material_Dialog_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_material_dialog_desc = /** @type {((inputs?: Packaging_Material_Dialog_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Material_Dialog_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_material_dialog_desc(inputs)
});